<div class="filters-container">
  @for (filter of filters; track filter; let last = $last) {
    <div class="filter-container">
      <p-select
        class="filter-select"
        [options]="filterDefs"
        [(ngModel)]="filter.filterDef"
        (ngModelChange)="setFilterOperator(filter, $event.operators[0])"
        optionLabel="label"
        [filter]="true"
        filterBy="label"
        >
        <ng-template let-selectedFilter pTemplate="selectedItem">
          @if (selectedFilter) {
            <div>
              {{selectedFilter.label}}
            </div>
          }
        </ng-template>
      </p-select>
      <p-select
        class="operator-select"
        [options]="filter.filterDef.operators"
        [ngModel]="filter.operator"
        (ngModelChange)="setFilterOperator(filter, $event)"
        optionLabel="label"
        [filter]="true"
        filterBy="label"
        >
        <ng-template let-selectedOperator pTemplate="selectedItem">
          @if (selectedOperator) {
            <div>
              {{selectedOperator.label}}
            </div>
          }
        </ng-template>
      </p-select>
      @switch (filter.operator.inputType) {
        @case ('text') {
          <input class="query-input" type="text" pInputText [(ngModel)]="filter.query" (keyup.enter)="onFilterChange()" />
        }
        @case('multiselect') {
          <p-autoComplete
            class="query-input"
            [(ngModel)]="filter.query"
            [suggestions]="filter.suggestions || []"
            (completeMethod)="multiselectComplete($event, filter)"
            [optionValue]="queryAutocompleteValueFn"
            [multiple]="true"
            [forceSelection]="true"
            [completeOnFocus]="true"
            (keyup.enter)="onFilterChange()"
          >
          <ng-template let-item pTemplate="item">
            {{ item.label }}
          </ng-template>
          <ng-template let-item pTemplate="selecteditem">
            {{ item.label }}
          </ng-template>
        </p-autoComplete>
        }
      }
      @if (filters.length > 1) {
        <p-button icon="pi pi-minus" [rounded]="true" (onClick)="removeFilter(filter)" />
      }
      @if (last) {
        <p-button icon="pi pi-plus" [rounded]="true" (onClick)="addFilter()" />
      }
      @if (last) {
        <p-button
          (onClick)="onFilterChange()"
          [disabled]="isLoading"
          label="Filter"
          i18n-label="filter|Apply filter button"
        />
      }
    </div>
  }
</div>